import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import { urlify } from '../../../utils/string';
import s from './Heading.scss';

const Heading = ({ content, attrs = {}, isPuffContent = false, article = false }) => {
	const style = {};
	const headingStyle = {};
	const HeadingTag = `h${content?.level || '2'}`;
	let headingClasses = [s.heading];
	if (isPuffContent && !article) headingClasses.push(s.heading__puffContent);
	if (attrs.className) headingClasses = [...headingClasses, attrs.className.map((cN) => s[`heading${cN}`])];
	if (attrs.align) headingClasses = [...headingClasses, s[`heading__${attrs.align}`]];
	if (attrs.textColor) style.color = attrs.textColor;
	if (attrs.textAlign) style.textAlign = attrs.textAlign;
	if (attrs.padding) {
		style.padding = attrs.padding.join(' ');
		style.boxSizing = 'border-box';
	}
	if (attrs.fontFamily) headingClasses = [...headingClasses, s[`heading__${attrs.fontFamily}`]];
	if (attrs.fontWeight && [300, 400, 600, 700].indexOf(parseInt(attrs.fontWeight, 10)) !== -1) style.fontWeight = parseInt(attrs.fontWeight, 10);
	if (attrs.textTransform) {
		style.textTransform = attrs.textTransform;
		headingStyle.lineHeight = '1.2em';
	}

	return (
		<div id={urlify(content.rawText)} className={headingClasses.join(' ')} style={style}>
			<HeadingTag className={[s.heading_inner, (attrs.fontSize ? `u_fontSize__${attrs.fontSize}` : null)].join(' ')} style={headingStyle} dangerouslySetInnerHTML={{ __html: purifier(content.rawText) }} />
		</div>
	);
};

export default hot(module)(Heading);
